export default {"src":"/_next/static/media/subSol5.a7328da6.svg","height":50,"width":62};